import ko from 'knockout'

function validatemixin (params) {
  this.validate = params.validate || function () { }
  if (params.validate) {
    this.validate(false)
  } else {
    this.validate(true)
  }
  this.judgeValidate = (val) => {
    // 如果不传入validate那么就默认认为检验通过
    if (params.validate) {
      if (val) {
        this.validate(true)
      } else {
        this.validate(false)
      }
    } else {
      this.validate(true)
    }
  }
}

function refmixin (params) {
  if (params.ref) {
    if (window.YCLOUD_REFS) {
      let refs = window.YCLOUD_REFS
      refs[params.ref] = this
    } else {
      window.YCLOUD_REFS = {}
      window.YCLOUD_REFS[params.ref] = this
    }
  }
}

function changeStyleMixin (params) {
  // 用于input特殊的修改标记，如果值被改变，则变红
  this.oldValue = ko.utils.unwrapObservable(this.value)
  this.textChanged = ko.observable(false)
  this.enableChangingStyle = params.enableChangingStyle || false
  this.value.subscribe && this.value.subscribe(value => {
    if (this.enableChangingStyle && this.oldValue === '') {
      this.oldValue = value
    }
  })
}

function gridRefMixin (params) {
  if (params.gridRef) {
    params.gridRef[0].set(this, params.gridRef[1], params.gridRef[2])
    // 通常表格列不超过30
    this.tabindex = (params.gridRef[1] + 1) * 30 + params.gridRef[2]
  }
  this.tabindex = this.tabindex || ''
}
export {
  refmixin,
  validatemixin,
  changeStyleMixin,
  gridRefMixin
}



// WEBPACK FOOTER //
// ./src/mixin/index.js